export enum Status {
    LOADING = 'LOADING',
    READY = 'READY',
}
